import { render, staticRenderFns } from "./StorageViewer.vue?vue&type=template&id=ddd8cc38&scoped=true"
import script from "./StorageViewer.vue?vue&type=script&lang=js"
export * from "./StorageViewer.vue?vue&type=script&lang=js"
import style0 from "./StorageViewer.vue?vue&type=style&index=0&id=ddd8cc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8cc38",
  null
  
)

export default component.exports